/**
 * Zyklus-/Wochenlogik für mehrwöchige Arbeitszeitmodelle (lange/kurze Woche).
 * Rein & abhängigkeitsfrei (nutzbar in Main, Preload und Renderer).
 *
 * Ein globaler Anker-Montag (`zyklus_anker_datum`, Einstellung) markiert den Beginn
 * von „Woche 1". Für jedes Datum ergibt sich die Zyklus-Woche aus der Anzahl ganzer
 * Wochen seit dem Anker, modulo Zykluslänge des Mitarbeiters.
 */

const MS_PRO_TAG = 86_400_000

/** ISO-Datum (YYYY-MM-DD) → UTC-Millisekunden des Tagesbeginns. */
function parseUtc(iso: string): number {
  const [j, m, t] = iso.split('-').map(Number)
  return Date.UTC(j, (m ?? 1) - 1, t ?? 1)
}

/** UTC-Zeitpunkt → Montag 00:00 UTC derselben Kalenderwoche (Mo=Wochenstart). */
function montagUtc(ms: number): number {
  const tag = new Date(ms).getUTCDay() // 0=So … 6=Sa
  const versatz = (tag + 6) % 7 // Tage seit Montag
  return ms - versatz * MS_PRO_TAG
}

/**
 * Liefert die Zyklus-Woche (1..zyklusWochen) für ein Datum.
 * Bei `zyklusWochen <= 1` immer 1 (Standardfall: jede Woche gleich).
 */
export function wocheFuerDatum(datumIso: string, zyklusWochen: number, ankerIso: string): number {
  if (!Number.isFinite(zyklusWochen) || zyklusWochen <= 1) return 1
  const wochenDiff = Math.round(
    (montagUtc(parseUtc(datumIso)) - montagUtc(parseUtc(ankerIso))) / (7 * MS_PRO_TAG)
  )
  const idx = ((wochenDiff % zyklusWochen) + zyklusWochen) % zyklusWochen
  return idx + 1
}
